import React from 'react';

import Box from '../Box/Box';
import parentName from './name';
import TTextField from './@types/TextField';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';

// eslint-disable-next-line react/display-name
const TextFieldInput = React.forwardRef(
  (
    {
      id,
      isRequired = false,
      onChange,
      value,
      name,
      type = 'text',
      ariaLabel,
      ariaLabelledBy,
      helperTextId,
      errorTextId,
      charsExceededId,
      ...rest
    }: TTextField,
    ref,
  ) => {
    const conditionalProps = filterConditionalKeyValues({
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
    });

    // Build aria-describedby to include helper text, error text, and chars exceeded
    const describedByIds = [helperTextId, errorTextId, charsExceededId].filter(Boolean).join(' ');

    return (
      <Box
        {...rest}
        {...conditionalProps}
        parent={parentName}
        name="input"
        as="input"
        id={id}
        htmlNameAttr={name || id}
        type={type}
        onChange={onChange}
        ref={ref}
        required={isRequired}
        value={value}
        aria-describedby={describedByIds || undefined}
        aria-invalid={errorTextId || charsExceededId ? 'true' : 'false'}
      />
    );
  },
);

export default TextFieldInput;
